import { useParams } from 'wouter'

import { Layout as LayoutDefault } from '@/features/layout'
import { Suspense } from '@/components/ui/Suspense'
import { CheckPermission, Permission } from '@/features/auth'

function Layout({
  categorySlug,
  layoutVersion
}: {
  categorySlug?: string
  layoutVersion?: number
}) {
  return (
    <LayoutDefault categorySlug={categorySlug} layoutVersion={layoutVersion} />
  )
}

export default function LayoutSuspense() {
  const params = useParams() as { categorySlug: string; layoutVersion: string }

  if (!params) return null

  return (
    <CheckPermission
      permissions={[Permission.LAYOUT_READ]}
      redirect={'/goodies'}
    >
      <Suspense isFullPage>
        <Layout
          categorySlug={params.categorySlug}
          layoutVersion={
            params.layoutVersion ? parseInt(params.layoutVersion) : undefined
          }
        />
      </Suspense>
    </CheckPermission>
  )
}
